import { useCallback, useState } from 'react';

import { getNoticeCompanyCriteriaDocuments } from '../../../../../api/theHive/notices';
import { CriteriaAnalysisData } from '../../../../../api/theHive/notices/types';
import { Constants } from '../../../../../constants/hiveNotices';
import useErrorMessage from '../../../../../hooks/useErrorMessage';
import useSnackbar from '../../../../../hooks/useSnackbar';
import { isCriteriaAnalysisData } from './utils';

interface UseCriteriaDocumentsHook {
  documents: CriteriaAnalysisData | undefined;
  loading: boolean;
  fetchDocuments: () => Promise<void>;
}

export default function useCriteriaDocuments(
  noticeCompanyId: number,
  noticeCompanyUserId?: number
): UseCriteriaDocumentsHook {
  const [documents, setDocuments] = useState<CriteriaAnalysisData>();
  const [loading, setLoading] = useState(false);

  const { getErrorMessage } = useErrorMessage();
  const { handleSnackbar } = useSnackbar();

  const fetchDocuments = useCallback(async (): Promise<void> => {
    setLoading(true);
    try {
      const response = await getNoticeCompanyCriteriaDocuments(
        noticeCompanyId,
        noticeCompanyUserId
      );

      if (response.detail.description)
        throw new Error(response.detail.description);

      if (!isCriteriaAnalysisData(response.data))
        throw new Error(Constants.genericError);

      setDocuments(response.data);
    } catch (error) {
      handleSnackbar(getErrorMessage(error), true);
    } finally {
      setLoading(false);
    }
  }, [noticeCompanyId, noticeCompanyUserId, getErrorMessage, handleSnackbar]);

  return { documents, loading, fetchDocuments };
}
